const initialState = {
    loaded: false,
    data: Object.create(null),
};
export default initialState;
